/** string manipulation utilities */
import { isString } from 'lodash-es';

export const lowerize = s =>
  (s && s.charAt(0).toLowerCase() + s.slice(1)) || '';

/**
 * If `value` is a string consisting only of integers cast it to a number
 * otherwise return it as it was supplied
 *
 * @param {*} value
 * @returns {number|*}
 */
export const castDigitsToInt = value =>
  isString(value) && /^\d+$/.test(value) ? Number(value) : value;
